export default __webpack_public_path__ + "static/media/Logo Black.70e67a23.svg";